import { useState } from "react";
import useLocalStorage from "./Hook/LocalStorage";
import AddTaskForm from "./components/AddTaskForm";
import TaskItem from "./components/TaskItem";
import FilterButtons from "./components/Button";
import "./App.css";
import Footer from "./components/Footer";

function App() {
  const [tasks, setTasks] = useLocalStorage("task", []);
  const [filter, setFilter] = useState("all");

  const addTask = (text) => {
    const newTask = {
      id: Date.now(),
      text,
      completed: false,
    };
    setTasks((prevTasks) => [...prevTasks, newTask]);
  };

  const toggleTask = (id) => {
    const updatedTasks = tasks.map((task) =>
      task.id === id ? { ...task, completed: !task.completed } : task
    );
    setTasks(updatedTasks);
  };

  const deleteTask = (id) => {
    setTasks(tasks.filter((task) => task.id !== id));
  };

  const filteredTasks = tasks.filter((task) => {
    if (filter === "active") return !task.completed;
    if (filter === "completed") return task.completed;
    return true;
  });

  return (
    <>
      <h1 className="topHeading">Task Manager App</h1>
      <AddTaskForm onAdd={addTask} />
      <FilterButtons filter={filter} setFilter={setFilter} />
      {filteredTasks.map((task) => (
        <TaskItem
          key={task.id}
          task={task}
          onToggle={toggleTask}
          onDelete={deleteTask}
        />
      ))}

      <Footer />
    </>
  );
}

export default App;
